import { render } from "./DialogNotOpenService.vue?vue&type=template&id=66364714"
import script from "./DialogNotOpenService.vue?vue&type=script&lang=js"
export * from "./DialogNotOpenService.vue?vue&type=script&lang=js"
script.render = render

export default script